import { del, get } from "aws-amplify/api";
import { API_NAME_VELAVU, normalizePromiseError, operationToJSON } from "../util/amplify-utils";
export default class VelavuApiAssetRoutes {
    //This method returns all of an asset's routes.
    //https://docs.velavu.com/#get-all-routes
    getAllRoutes(asset_id, params) {
        const query = {};
        if (params?.since !== undefined) {
            query["since"] = params.since.toISOString();
        }
        if (params?.until !== undefined) {
            query["until"] = params.until.toISOString();
        }
        return normalizePromiseError(operationToJSON(get({
            apiName: API_NAME_VELAVU,
            path: `/assets/${asset_id}/routes`,
            options: {
                queryParams: query,
            },
        })));
    }
    //This method returns a specific route.
    //https://docs.velavu.com/#get-a-specific-route
    getSpecificRoute(asset_id, route_id) {
        return normalizePromiseError(operationToJSON(get({
            apiName: API_NAME_VELAVU,
            path: `/assets/${asset_id}/routes/${route_id}`,
        })));
    }
    //Delete a Specific Route
    //https://docs.velavu.com/#delete-a-specific-route
    deleteSpecificRoute(asset_id, route_id) {
        return normalizePromiseError(del({
            apiName: API_NAME_VELAVU,
            path: `/assets/${asset_id}/routes/${route_id}`,
        }).response);
    }
}
//# sourceMappingURL=velavu-api-asset-routes.js.map